

import styled from "styled-components";

export default function Footer() {
    return (
        <Container>
            <Copyright><span><a href="https://tanahair.indonesia.go.id/sikambing" target="_blank">SIKAMBING</a> © 2021 @ Badan Informasi Geospasial</span></Copyright>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #eee;
  width: 100%;
`;

const Copyright = styled.p`
  font-size: 12px;
  font-weight: 600;
`;